export default __webpack_public_path__ + "static/poster-1-b4a2ec9a2cb70e27d0468884e4e6522a.webm";